import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-6 pb-5 px-4 relative overflow-hidden" data-id="element-101">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-102">
        <div className="inline-block bg-yellow-400 text-black font-black px-3 py-1.5 rounded-full text-[10px] md:text-xs mb-4 uppercase tracking-widest shadow-[0_0_15px_rgba(250,204,21,0.4)]" data-id="element-103">
          ⭐ EL RECURSO #1 PARA DOCENTES DE EDUCACIÓN FINANCIERA Y
          EMPRENDIMIENTO ⭐
        </div>

        <h1 className="text-xl md:text-3xl lg:text-4xl font-black mb-4 leading-tight text-white tracking-tight uppercase" data-id="element-104">
          Dejá de perder horas preparando clases, actividades y evaluaciones{' '}
          <span className="text-brand-accent neon-glow" data-id="element-105">desde cero</span>
        </h1>

        <div className="w-full max-w-[360px] md:max-w-md mx-auto my-3 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 relative" onClick={scrollToCompra} role="button" aria-label="Ver oferta del Kit" data-id="element-106">
          <div className="absolute inset-0 bg-brand-accent/25 blur-3xl rounded-full" data-id="element-107"></div>
          <img src="https://cdn.magicpatterns.com/uploads/2fPtYT4ZLqjq1cwoHQzRd3/conjunto_de_mockups_educacion_financiera_(1).png" alt="Kit Completo Educación Financiera Lista" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-108" />
        </div>

        <p className="text-base md:text-xl font-black text-brand-accent neon-glow mb-2 uppercase tracking-tight" data-id="element-109">
          Todo listo para usar. Sin buscar más.
        </p>

        <p className="text-sm md:text-base mb-5 font-bold text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-110">
          El sistema que usan los docentes para planificar{' '}
          <span className="text-white font-black" data-id="element-111">TODO el año</span> en una sola
          tarde.
        </p>

        <div className="w-full max-w-md mx-auto mb-4" data-id="element-112">
          <Button className="text-base md:text-xl py-3 md:py-4 shadow-[0_0_30px_rgba(34,197,94,0.55)]" data-id="element-113">
            → QUIERO MI KIT COMPLETO AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[10px] md:text-xs text-gray-400 font-bold" data-id="element-114">
          <div className="flex items-center" data-id="element-115">
            <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-116" />
            <span data-id="element-117">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-118">
            <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-119" />
            <span data-id="element-120">Pago seguro</span>
          </div>
          <div className="flex items-center" data-id="element-121">
            <Zap className="w-3 h-3 mr-1 text-brand-accent" data-id="element-122" />
            <span data-id="element-123">Acceso inmediato</span>
          </div>
          <div className="flex items-center" data-id="element-124">
            <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-125" />
            <span data-id="element-126">Pagás en tu moneda local</span>
          </div>
        </div>
      </div>
    </section>;
}